import {
  ADD_FORGOT_PASSWORD_FIELD_ERROR,
  CHANGE_FORGOT_PASSWORD_FORM_FIELD,
  CLEAR_FORGOT_PASSWORD_FIELD_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_FAILURE,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
} from './actions'

export interface ForgotPasswordState {
  formData: { email: string }
  resetEmailSend: boolean
  errors: Record<string, string | undefined>
  loading: boolean
}

export const initialState = (): ForgotPasswordState => ({
  formData: { email: '' },
  resetEmailSend: false,
  errors: {},
  loading: false,
})

type Action =
  | ReturnType<typeof import('./actions').changeForgotPasswordFormField>
  | ReturnType<typeof import('./actions').forgotPasswordRequest>
  | ReturnType<typeof import('./actions').forgotPasswordSuccess>
  | ReturnType<typeof import('./actions').forgotPasswordFailure>
  | ReturnType<typeof import('./actions').addFieldError>
  | ReturnType<typeof import('./actions').clearFieldError>

export default function reducer(
  state: ForgotPasswordState = initialState(),
  action: Action,
): ForgotPasswordState {
  switch (action.type) {
    case CHANGE_FORGOT_PASSWORD_FORM_FIELD:
      return {
        ...state,
        formData: { ...state.formData, [action.payload.key]: action.payload.value },
      }
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, loading: true, errors: {} }
    case FORGOT_PASSWORD_REQUEST_SUCCESS:
      return { ...state, resetEmailSend: true, loading: false }
    case FORGOT_PASSWORD_REQUEST_FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case ADD_FORGOT_PASSWORD_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: action.payload.error } }
    case CLEAR_FORGOT_PASSWORD_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: undefined } }
    default:
      return state
  }
}
